import { getBasePath } from "@/config/basePath";

const basePath = getBasePath();

/**
 * Internal Next.js API routes (route.ts handlers).
 *
 * Almost all auth flows use server actions. The only routes that remain are
 * the ones that need a stable, browser-addressable URL:
 *   - HEALTH:  Docker / load-balancer healthcheck
 *   - LOGOUT:  GET-only redirect endpoint for 401 fallbacks and `<a>` links
 */
export const NEXT_API_ROUTES = {
  HEALTH: `${basePath}/api/health`,
  LOGOUT: `${basePath}/api/auth/logout`,
  /** Long-lived session stream (GET NDJSON). */
  AI_GATEWAY_STREAM: `${basePath}/api/ai-gateway/stream`,
  /** Client → gateway JSON frames. */
  AI_GATEWAY_STREAM_SEND: `${basePath}/api/ai-gateway/stream/send`,
  /** Client → gateway raw PCM binary. */
  AI_GATEWAY_STREAM_AUDIO: `${basePath}/api/ai-gateway/stream/audio`,
} as const;

export const LOGOUT_ENDPOINT_INSIDE = NEXT_API_ROUTES.LOGOUT;
export const HEALTH_ENDPOINT_INSIDE = NEXT_API_ROUTES.HEALTH;

export const AI_GATEWAY_STREAM_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.AI_GATEWAY_STREAM;
export const AI_GATEWAY_STREAM_SEND_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.AI_GATEWAY_STREAM_SEND;
export const AI_GATEWAY_STREAM_AUDIO_ENDPOINT_INSIDE =
  NEXT_API_ROUTES.AI_GATEWAY_STREAM_AUDIO;
